<template>
  <div v-if="visible" class="modal-acordo">
    <div class="modal-overlay" @click="fechar" />
    <div class="modal-content">
      <FormSpinner  v-if="carregandoTermo"/>
      <!-- HEADER -->
      <header class="modal-header">
        <h2>
          <span class="step"><strong>{{ step }}</strong>/{{ totalSteps }}</span>
          {{ title }}
        </h2>
      </header>

    <!-- RESUMO SUPERIOR -->
    <section class="modal-main">
      <div class="modal-summary" v-if="step !== 4">
        <div class="summary-text">
          <h3 class="summary-main">{{ resumoLinha1 }}</h3>
          <h3 class="summary-sub" v-if="resumoLinha2">{{ resumoLinha2 }}</h3>
        </div>
        <div class="summary-total">
          <h1>{{ currency(total) }}</h1>
        </div>
      </div>

    <!-- Campo seleção de método de pagamento -->
    <div class="modal-body" v-if="step === 1">
    <div class="modal-escolha" v-if="formasDisponiveisEntrada.length > 0">
      <div class="field-label">
        <h4>Forma de Entrada</h4>
      </div>
      <div class="field-selecao">
        <switch-control
          v-for="forma in formasDisponiveisEntrada"
          :key="forma"
          :labelOn="forma.charAt(0).toUpperCase() + forma.slice(1)"
          :labelOff="forma.charAt(0).toUpperCase() + forma.slice(1)"
          :checked="entradaTipo === forma"
          :disabled="formasDisponiveisEntrada.length === 1"
          @update:checked="entradaTipo = forma"
        />
      </div>
    </div>


    <!-- CONTAINER DE PARCELAMENTO -->
    <div class="modal-escolha" v-if="formasDisponiveisParcelamento.length > 0">
      <div class="field-label">
        <h4>Forma de Parcelamento</h4>
      </div>
      <div class="field-selecao">
        <switch-control
          v-for="forma in formasDisponiveisParcelamento"
          :key="forma"
          :labelOn="forma.charAt(0).toUpperCase() + forma.slice(1)"
          :labelOff="forma.charAt(0).toUpperCase() + forma.slice(1)"
          :checked="parcelaTipo === forma"
          :disabled="!parcelamentoHabilitado(forma)"
          @update:checked="parcelaTipo = forma"
        />
      </div>
    </div>

    </div>


      <!-- CORPO: ENTRADA E PARCELAS -->
      <div v-if="step === 2" class="modal-body">
      <template v-if="mostrarCampoEntrada || mostrarCampoParcelamento">
        <div class="field" v-if="mostrarCampoEntrada">
          <div class="field-label">
            <h4>
              Entrada
            </h4>
            <small v-if="temRangeEntrada">De {{ minEntrada }}% até {{ maxEntrada }}%</small>
          </div>
          <div class="field-control">
            <div class="input-circle">
              <input
                type="number"
                placeholder="35"
                v-model.number="entradaPercent"
                :min="minEntrada"
                :max="maxEntrada"
              />
              <span class="unit">%</span>
            </div>
            <div class="field-equals">
              <h5>=</h5>
              <h3><strong>{{ currency(valorEntrada) }}</strong></h3>
            </div>
          </div>
        </div>

        <div class="field" v-if="mostrarCampoEntrada && entradaParcelada">
          <div class="field-label">
            <h4>Parcelas da Entrada</h4>
            <small>Máximo de {{ parcelasEntrada }}x</small>
          </div>
          <div class="field-control">
            <div class="input-circle">
              <input
                type="number"
                v-model.number="qtdParcelasEntrada"
                :min="1"
                :max="parcelasEntrada"
                placeholder="1"
              />
              <span class="unit">x</span>
            </div>
            <div class="field-equals">
              <h5>=</h5>
              <h3><strong>{{ currency(valorParcelaEntrada) }}</strong></h3>
            </div>
          </div>
        </div>


        <div class="field" v-if="mostrarCampoParcelamento">
          <div class="field-label">
            <h4>Parcelas</h4>
            <small>De 1 a {{ maxParcelas }}x</small>
          </div>
          <div class="field-control">
            <div class="input-circle">
              <input
                type="number"
                v-model.number="parcelas"
                placeholder="3"
                min="1"
                :max="maxParcelas"
              />
              <span class="unit">x</span>
            </div>
            <div class="field-equals">
              <h5>=</h5>
              <h3><strong>{{ currency(valorParcela) }}</strong></h3>
            </div>
          </div>
        </div>
      </template>

      <template v-else>
        <p class="text-muted">Essa forma de pagamento não possui condições ajustáveis.</p>
      </template>
    </div>

      <div v-if="step === 3" class="modal-body-3">
      <table class="tabela-parcelas">
        <tbody>
          <tr v-for="(parcela, index) in parcelasCalculadas" :key="index">
            <td class="number-boleto">{{ String(index + 1).padStart(2, '0') }}</td>
            <td>
            <template v-if="parcela.tipoArrecadacao === 'entrada'">Entrada</template>
            <template v-else-if="parcela.tipoArrecadacao === 'avista'">À vista</template>
            <template v-else>Parcela {{ parcela.parcela }}</template>
          </td>

            <td>
              <!-- CARTÃO: mostra só mês/ano fixo -->
              <template v-if="isCartao(parcela)">
                <span class="month-pill">{{ formatMonthBR(parcela.vencimento) }}</span>
              </template>

              <template v-else-if="isPix(parcela)">
                <span>{{ formatDateBR(parcela.vencimento) }}</span>
              </template>

              <template v-else>
                <input
                  type="date"
                  v-model="parcela.vencimento"
                  :lang="'pt-BR'"
                  :min="baseVencimento(parcela, index)"
                  :max="addDias(baseVencimento(parcela, index), 5)"
                  class="input-control"
                />
              </template>
            </td>





            <td>{{ currency(parcela.valor) }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-if="step === 4" class="modal-body-4">
      <main class="tabela-acordo text-center">
        <vue-pdf-embed v-if="termo" :source="termo"/>
        <div v-else>
          <h3>Aguarde. Carregando...</h3> 
        </div>
      </main>
    </div>
    </section>

      <!-- FOOTER -->
      <footer class="modal-footer">
        <button class="btn  btn-secondary" @click="onVoltar()" :disabled="carregandoTermo">
          Voltar
        </button>
        <button class="btn btn-primary" @click="onContinuar()" :disabled="carregandoTermo">
          {{ step === 4 ? 'Finalizar' : 'Continuar' }}
        </button>
        <button v-if="step === 4" class="btn btn-primary-light" @click="copiar" :disabled="carregandoTermo">
          Copiar link de proposta
        </button>
      </footer>
    </div>
  </div>
</template>

<script>

import VuePdfEmbed from 'vue-pdf-embed'
import NegociaService from '@/services/negocieja.service'
import FormSpinner from '@/components/utilities/FormSpinner.vue'
import { formatDate } from '@/services/utils.service.js'
import moment from 'moment'
import 'moment/locale/pt-br'

export default {
    components:{
    VuePdfEmbed, FormSpinner
  },
  name: 'ModalAcordo',
  props: {
    visible: { type: Boolean, default: false },
    forma: { type: Object,  required: true },
    step: { type: Number,  default: 1 },
    totalSteps: { type: Number,  default: 4 },
    title: { type: String,  default: 'Confirmação do Acordo' },
    valorOriginal: { type: Number, required: true },
    cpf: { type: String, required: true }, 
    mencodigos: { type: Array, required: true } 
  },
  data() {
    return {
      uuid: null,
      termo: null,
      carregandoTermo: false,
      entradaPercent: '',
      entradaTipo: '',
      parcelaTipo: '',
      parcelas: '',
      qtdParcelasEntrada: '',
      baseDates: {},
      model: {
        "cpf_responsavel_financeiro": "",
        "mencodigos": [
        ], 
        "valor": {
          totalOriginal: '',
          totalFinal: ''  
        },
        "formaPagamento": {
            idFormaPagamento: '',
            percentualEntrada: '', //pode ser nulo caso a forma de pagamento não tenha esse parametro
            qtdParcelas: '', //pode ser nulo caso a forma de pagamento não tenha esse parametro
            //os parametros não estaram dispponiveis caso a forma de pagamento não seja variavel nesse caso as regras estarão disponiveis na configuração da forma de pagamento
        },
        
        "parcelas": [
        ]
      }
    }
  },

  mounted() {
  if (this.formasDisponiveisEntrada.length === 1)
    this.entradaTipo = this.formasDisponiveisEntrada[0]

  if (this.formasDisponiveisParcelamento.length === 1)
    this.parcelaTipo = this.formasDisponiveisParcelamento[0]
  },
  
  computed: {

    matrizCompatibilidade() {
      return {
        cartao: ['boleto'],
        pix: ['boleto'],
        boleto: ['boleto'],
        none: ['pix', 'boleto', 'cartao'] 
      }
    },

    formasParcelamentoValidas() {
      const base = this.formasDisponiveisParcelamento

      if (!this.temEntrada) {
        return base.filter(f => this.matrizCompatibilidade.none.includes(f))
      }

      if (!this.entradaTipo) return []

      const permitidas = this.matrizCompatibilidade[this.entradaTipo] || []
      return base.filter(f => permitidas.includes(f))
    },
  
    formasDisponiveisEntrada() {
      const entrada = this.forma?.entrada || {}
      const formas = []

      if (entrada.pix && (entrada.percentualMinimoPix || entrada.maximoParcelasPix)) {
        formas.push('pix')
      }
      if (entrada.boleto && (entrada.percentualMinimoBoleto || entrada.maximoParcelasBoleto)) {
        formas.push('boleto')
      }
      if (entrada.cartao && (entrada.percentualMinimoCartao || entrada.maximoParcelasCartao)) {
        formas.push('cartao')
      }

      return formas
    },
    formasDisponiveisParcelamento() {
      const parcelas = this.forma?.parcelas || {}
      const formas = []

      if (parcelas.pix) {
        formas.push('pix')
      }
      if (parcelas.boleto && (parcelas.maximoParcelasBoleto || 0) > 0) {
        formas.push('boleto')
      }
      if (parcelas.cartao && (parcelas.maximoParcelasCartao || 0) > 0) {
        formas.push('cartao')
      }

      return formas
    },
    valorParcelaEntrada() {
      if (!this.temEntrada || !this.entradaParcelada) return this.valorEntrada
      return this.valorEntrada / this.qtdParcelasEntrada
    },
  mostrarCampoEntrada() {
    const entrada = this.forma?.entrada?.cartao
    const minPercentuais = [
      this.forma?.entrada?.percentualMinimoCartao,
      this.forma?.entrada?.percentualMinimoBoleto,
      this.forma?.entrada?.percentualMinimoPix
    ]
    return entrada || minPercentuais.some(p => p && p > 0)
  },
  mostrarCampoParcelamento() {
    const maxParcelas = [
      this.forma?.parcelas?.cartao?.parcelas,
      this.forma?.parcelas?.boleto,
      this.forma?.parcelas?.pix,
      this.forma?.parcelas?.maximoParcelasCartao,
      this.forma?.parcelas?.maximoParcelasBoleto,
      this.forma?.parcelas?.maximoParcelasPix
    ]

    return maxParcelas.some(p => parseInt(p) > 1)
  },
  temEntrada() {
    return this.formasDisponiveisEntrada.length > 0
  },
  entradaParcelada() {
    return this.forma?.entrada?.cartao?.parcelasEntrada && parseInt(this.forma.entrada.cartao.parcelasEntrada) > 1
  },
  parcelasEntrada() {
    if (!this.entradaTipo || !this.forma?.entrada) return 1

    const tipo = this.entradaTipo.toLowerCase()
    const maxKey = `maximoParcelas${tipo.charAt(0).toUpperCase() + tipo.slice(1)}`
    return parseInt(this.forma.entrada[maxKey]) || 1
  },
  temRangeEntrada() {
    return this.minEntrada !== null && this.maxEntrada !== null
  },
  parcelasCalculadas() {
    const lista = []
    const isPersonalizavel = this.mostrarCampoEntrada || this.mostrarCampoParcelamento

    const basePrimeira = this.proximoDiaUtilEmNDias(5)
    const hojeISO = this.dataHoje()
    const usarHojeEntrada = this.entradaTipo === 'pix'
    const usarHojeParcelas = this.parcelaTipo === 'pix'

    if (!isPersonalizavel) {
      const vencimento = usarHojeParcelas ? hojeISO : basePrimeira

      lista.push({
        tipoArrecadacao: 'parcela',
        parcela: 1,
        vencimento,
        valor: this.total
      })
      return lista
    }

    let primeiraEntradaISO = null
    let ultimaEntradaISO = null

    if (this.mostrarCampoEntrada) {
      if (this.entradaParcelada && this.qtdParcelasEntrada > 1) {
        for (let i = 0; i < this.qtdParcelasEntrada; i++) {
          const alvo = moment(basePrimeira).add(i, 'months').format('YYYY-MM-DD')
          const venc = usarHojeEntrada
            ? hojeISO
            : this.ajustarPreferindoMesmoMes(alvo)

          lista.push({
            tipoArrecadacao: 'entrada',
            parcela: i + 1,
            vencimento: venc,
            valor: this.valorParcelaEntrada
          })

          if (!primeiraEntradaISO) primeiraEntradaISO = venc
          ultimaEntradaISO = venc
        }
      } else {
        const venc = usarHojeEntrada
          ? hojeISO
          : this.ajustarPreferindoMesmoMes(basePrimeira)

        lista.push({
          tipoArrecadacao: 'entrada',
          parcela: 1,
          vencimento: venc,
          valor: this.valorEntrada
        })

        primeiraEntradaISO = venc
        ultimaEntradaISO = venc
      }
    }

    if (this.mostrarCampoParcelamento && this.parcelas && this.parcelas > 0) {
      const baseParcelas = (() => {
        if (this.mostrarCampoEntrada) {
          if (this.entradaTipo === 'cartao' && primeiraEntradaISO) {
            return moment(primeiraEntradaISO).add(1, 'months').format('YYYY-MM-DD')
          }
          if (ultimaEntradaISO) {
            return moment(ultimaEntradaISO).add(1, 'months').format('YYYY-MM-DD')
          }
        }
        return basePrimeira
      })()

      for (let i = 0; i < this.parcelas; i++) {
        const alvo = moment(baseParcelas).add(i, 'months').format('YYYY-MM-DD')
        const venc = usarHojeParcelas
          ? hojeISO
          : this.ajustarPreferindoMesmoMes(alvo)

        lista.push({
          tipoArrecadacao: 'parcela',
          parcela: i + 1,
          vencimento: venc,
          valor: this.valorParcela
        })
      }
    }

    return lista
  },
    total() { return this.forma.valorFinalCobrado },
    minEntrada() {
      if (!this.entradaTipo || !this.forma?.entrada) return 0

      const tipo = this.entradaTipo.toLowerCase()
      return this.forma.entrada[`percentualMinimo${tipo.charAt(0).toUpperCase() + tipo.slice(1)}`] || 0
    },
    maxEntrada() {
      return 99
    },
    maxParcelas() {
      if (!this.parcelaTipo || !this.forma?.parcelas) return 1

      const tipo = this.parcelaTipo.toLowerCase()
      const maxKey = `maximoParcelas${tipo.charAt(0).toUpperCase() + tipo.slice(1)}`
      return parseInt(this.forma.parcelas[maxKey]) || 1
    },
    valorEntrada() {
      return this.temEntrada ? (this.entradaPercent / 100) * this.total : 0
    },
    valorParcela() {
      const valorBase = this.temEntrada ? (this.total - this.valorEntrada) : this.total
      return valorBase / this.parcelas
    },
    resumoLinha1() {
       return this.forma?.nome
    },
    resumoLinha2() {
      if (!this.mostrarCampoEntrada && !this.mostrarCampoParcelamento) {
        return null
      }

      if (!this.temEntrada) {
        return `${this.parcelas}x de ${this.currency(this.valorParcela)}`
      }

      return `Entrada de ${this.currency(this.valorEntrada)} + ${this.parcelas}x de ${this.currency(this.valorParcela)}`
    }
    
  },


    watch: {
      visible(novoValor) {
        if (novoValor) {
          this.resetarFormulario()

          if (this.formasDisponiveisEntrada.length === 1)
            this.entradaTipo = this.formasDisponiveisEntrada[0]

          if (this.formasDisponiveisParcelamento.length === 1)
            this.parcelaTipo = this.formasDisponiveisParcelamento[0]
        }
      },
      entradaTipo() {
        if (!this.parcelaTipo || !this.parcelamentoHabilitado(this.parcelaTipo)) {
          const primeiraHabilitada = this.formasDisponiveisParcelamento.find(f => this.parcelamentoHabilitado(f))
          this.parcelaTipo = primeiraHabilitada || ''
        }
      }
    },

  methods: {
    ultimoDiaUtilDoMes(iso) {
      const m = moment(iso, 'YYYY-MM-DD').endOf('month')
      let d = m.clone()
      while (d.day() === 0 || d.day() === 6) d = d.subtract(1, 'day')
      return d.format('YYYY-MM-DD')
    },

    formatDate(value) {
      return formatDate(value)
    },

    ajustarPreferindoMesmoMes(iso) {
      const alvo = moment(iso, 'YYYY-MM-DD')
      const adiantado = this.ajustarParaDiaUtil(iso)
      if (moment(adiantado, 'YYYY-MM-DD').isSame(alvo, 'month')) return adiantado
      return this.ultimoDiaUtilDoMes(iso)
    },

    ajustarParaDiaUtil(iso) {
      let m = moment(iso, 'YYYY-MM-DD')
      while (m.day() === 0 || m.day() === 6) {
        m = m.add(1, 'day')
      }
      return m.format('YYYY-MM-DD')
    },

    proximoDiaUtilEmNDias(n) {
      let m = moment().startOf('day')
      let count = 0
      while (count < n) {
        m = m.add(1, 'day')
        const dow = m.day()
        if (dow !== 0 && dow !== 6) count++
      }
      return m.format('YYYY-MM-DD')
    },

    formatMonthISO(iso) {
      if (!iso) return ''
      const [y, m] = iso.split('-')
      return `${y}-${String(m).padStart(2, '0')}`
    },

    baseVencimento(parcela, index) {
      const key = `${parcela.tipoArrecadacao}-${index}`
      if (!this.baseDates[key]) {
        this.baseDates[key] = parcela.vencimento
      }
      return this.baseDates[key]
    },

    isCartao(parcela) {
      if (parcela.tipoArrecadacao === 'parcela') return this.parcelaTipo === 'cartao'
      if (parcela.tipoArrecadacao === 'entrada') return this.entradaTipo === 'cartao'
      return false
    },

    isPix(parcela) {
      if (parcela.tipoArrecadacao === 'parcela') 
        return this.parcelaTipo === 'pix'

      if (parcela.tipoArrecadacao === 'entrada') 
        return this.entradaTipo === 'pix'

      return false
    },

    formatDateBR(iso) {
      if (!iso) return ''
      const [y, m, d] = iso.split('-')
      return `${String(d).padStart(2, '0')}/${String(m).padStart(2, '0')}/${y}`
    },

    formatMonthBR(iso) {
      if (!iso) return ''
      const [y, m] = iso.split('-')
      return `${String(m).padStart(2, '0')}/${y}`
    },

    parseDateBRToISO(str) {
      const m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(str)
      if (!m) return null
      const d = Number(m[1])
      const mo = Number(m[2])
      const y = Number(m[3])
      const date = new Date(y, mo - 1, d)
      if (date.getFullYear() !== y || date.getMonth() !== mo - 1 || date.getDate() !== d) return null
      return `${y}-${String(mo).padStart(2, '0')}-${String(d).padStart(2, '0')}`
    },

    onDateBRInput(e, parcela) {
      let v = e.target.value.replace(/\D/g, '').slice(0, 8)
      if (v.length >= 5) v = v.replace(/^(\d{2})(\d{2})(\d{0,4}).*$/, '$1/$2/$3')
      else if (v.length >= 3) v = v.replace(/^(\d{2})(\d{0,2}).*$/, '$1/$2')
      e.target.value = v
      parcela._inputBR = v
    },

    onDateBRBlur(parcela) {
      const raw = parcela._inputBR ?? this.formatDateBR(parcela.vencimento)
      const iso = this.parseDateBRToISO(raw)
      if (!iso) {
        window.toaster?.emit?.('open', {
          style: 'error',
          message: 'Data inválida. Use DD/MM/AAAA',
          floater: true
        })
      } else {
        parcela.vencimento = iso
      }
      parcela._inputBR = null
    },



  parcelamentoHabilitado(forma) {
    if (!this.temEntrada) return true

    if (!this.entradaTipo) return false

    const permitidas = this.matrizCompatibilidade[this.entradaTipo] || []
    return permitidas.includes(forma)
  },

  addDias(data, dias) {
    const novaData = new Date(data)
    novaData.setDate(novaData.getDate() + dias)
    return novaData.toISOString().substr(0, 10)
  },

    copiar() {
      if (!this.uuid) return

      const link = `${process.env.VUE_APP_APOLLO}negocieja/appPublic/negociar/termo/${this.uuid}`
      
      navigator.clipboard.writeText(link)
        .then(() => {
          window.toaster?.emit?.('open', {
            style: 'success',
            message: 'Link copiado para a área de transferência!',
            floater: true
          })
        })
        .catch(() => {
          window.toaster?.emit?.('open', {
            style: 'error',
            message: 'Erro ao copiar o link.',
            floater: true
          })
        })
    },

    resetarFormulario() {
      this.entradaPercent = ''
      this.entradaTipo = ''
      this.parcelaTipo = ''
      this.parcelas = ''
      this.qtdParcelasEntrada = ''
    },

    dataHoje() {
      return new Date().toISOString().substr(0, 10)
    },
    addMeses(data, meses) {
      const novaData = new Date(data)
      novaData.setMonth(novaData.getMonth() + meses)
      return novaData.toISOString().substr(0, 10)
    },
    onVoltar() {
      if (this.step > 1) {
        this.$emit('update:step', this.step - 1)
      } else {
        this.$emit('fechar')
      }
    },
onContinuar() {
  if (this.step === 1) {
    if (this.formasDisponiveisEntrada.length > 1 && !this.entradaTipo && this.temEntrada) {
      window.toaster?.emit?.('open', {
        style: 'error',
        message: 'Selecione uma forma de entrada.',
        floater: true
      })
      return
    }

  if (this.temEntrada) {
    const existeHabilitada = this.formasDisponiveisParcelamento.some(f => this.parcelamentoHabilitado(f))
    if (!existeHabilitada) {
      window.toaster?.emit?.('open', {
        style: 'error',
        message: 'A combinação escolhida não permite parcelamento.',
        floater: true
      })
      return
    }

    if (!this.parcelaTipo || !this.parcelamentoHabilitado(this.parcelaTipo)) {
      window.toaster?.emit?.('open', {
        style: 'error',
        message: 'Selecione uma forma de parcelamento válida.',
        floater: true
      })
      return
    }
  } else {
    if (this.formasDisponiveisParcelamento.length > 1 && !this.parcelaTipo) {
      window.toaster?.emit?.('open', {
        style: 'error',
        message: 'Selecione uma forma de parcelamento.',
        floater: true
      })
      return
    }
  }

    if (this.mostrarCampoEntrada && !this.entradaPercent) {
      this.entradaPercent = this.minEntrada
    }
    if (this.mostrarCampoParcelamento && !this.parcelas) {
      this.parcelas = this.maxParcelas
    }
    if (this.entradaParcelada && !this.qtdParcelasEntrada) {
      this.qtdParcelasEntrada = this.parcelasEntrada
    }
  }

  if (this.step === 2) {
    if (this.mostrarCampoEntrada) {
      if (this.entradaPercent < this.minEntrada || this.entradaPercent > this.maxEntrada) {
        window.toaster?.emit?.('open', {
          style: 'error',
          message: `A entrada deve estar entre ${this.minEntrada}% e ${this.maxEntrada}%.`,
          floater: true
        })
        return
      }
    }

    if (this.mostrarCampoParcelamento) {
      if (this.parcelas < 1 || this.parcelas > this.maxParcelas) {
        window.toaster?.emit?.('open', {
          style: 'error',
          message: `A quantidade de parcelas deve estar entre 1 e ${this.maxParcelas}.`,
          floater: true
        })
        return
      }
    }

    if (this.entradaParcelada) {
      if (this.qtdParcelasEntrada < 1 || this.qtdParcelasEntrada > this.parcelasEntrada) {
        window.toaster?.emit?.('open', {
          style: 'error',
          message: `A entrada pode ser parcelada em até ${this.parcelasEntrada}x.`,
          floater: true
        })
        return
      }
    }
  }

  if (this.step < this.totalSteps - 1) {
    this.$emit('update:step', this.step + 1)
  } else if (this.step === this.totalSteps - 1) {
    this.carregandoTermo = true

    const entradaParcelas = this.parcelasCalculadas.filter(p => p.tipoArrecadacao === 'entrada')
    const parcelaParcelas = this.parcelasCalculadas.filter(p => p.tipoArrecadacao === 'parcela')

    const payload = {
      cpf_responsavel_financeiro: this.cpf,
      mencodigos: this.mencodigos,
      valor: {
        totalOriginal: this.valorOriginal,
        totalFinal: this.total
      },
      idNegocieJaCampanha: this.forma.idNegocieJaCampanha ?? null,
      idNegocieJaPolitica: this.forma.idNegocieJaPolitica ?? null,
      formaPagamento: {
        idFormaPagamento: this.forma.idNegocieJaFormaPagamento,
        percentualEntrada: this.mostrarCampoEntrada ? this.entradaPercent : null,
        qtdParcelas: this.mostrarCampoParcelamento ? this.parcelas : null,
        qtdParcelasEntrada: this.entradaParcelada ? this.qtdParcelasEntrada : null
      },
      entrada: {
        pix: this.entradaTipo === 'pix' ? 1 : null,
        boleto: this.entradaTipo === 'boleto' ? 1 : null,
        cartao: this.entradaTipo === 'cartao' ? 1 : null,
        parcelas: entradaParcelas
      },
      parcelas: {
        pix: this.parcelaTipo === 'pix' ? 1 : null,
        boleto: this.parcelaTipo === 'boleto' ? 1 : null,
        cartao: this.parcelaTipo === 'cartao' ? 1 : null,
        parcelas: parcelaParcelas
      }
    }

    NegociaService.gerarProposta(payload)
      .then(res => {
        this.termo = `data:application/pdf;base64,${res.data.pdf}`
        this.uuid = res.data.uuid
        this.$emit('update:step', this.step + 1)
      })
      .catch(error => {
        window.toaster?.emit?.('open', {
          style: 'error',
          message: error.response?.data?.error || 'Erro ao gerar o termo de acordo.',
          floater: true
        })
      })
      .finally(() => {
        this.carregandoTermo = false
      })
  } else if (this.step === this.totalSteps) {
    this.$emit('fechar')
  }
},
    currency(val) {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency', currency: 'BRL'
      }).format(val)
    },
  },
}
</script>

<style lang="scss" scoped>

.month-pill {
  display: inline-block;
  padding: 0.4rem 0.6rem;
  background: $branco;
  color: $cinza-escuro;
  min-width: 6rem;
  text-align: center;
}


.modal-escolha{
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;


  .field-selecao{
    justify-content: center;
    align-items: center;
    width: 100%;
    display: flex;
    gap: $mg;
  }
}

.input-detail{
  color: $cinza-escuro;
}

.number-boleto{
  text-align: start !important;
}

.tabela-acordo{
  width: 100%;
  height: 100%;
  overflow-y: auto;

  @extend %scrollbar_light;

}

.tabela-parcelas{

  height: auto;

  input{
    padding: 0 !important;
    border: none;
    color: $cinza-escuro;

      &:focus {
        border: 0; outline: 0; box-shadow: none;
      }

    :focus{
      outline: none;
    }
  }
}

// .tabela-parcelas{
//   height: 20rem;
//   overflow-y: auto;


          table {

          width: 100%;
          padding: 0 !important; 
          border-collapse: collapse;
          overflow: hidden;

          thead {
            border-top: $border-component;

            tr {
              height: 50px;
              
              th {
                font-size: $font-size-small;
                padding: 0 $hmg_mid;
                text-align: center;

                &:nth-last-child( -n + 2 ) {
                  min-width: 280px; width: 20%; max-width: 360px;
                }
              }
            }
          }
          tbody {
            overflow: hidden;
            height: auto;
            border-top: $border-component;

            tr {
              height: 50px;
              overflow: hidden;

              td {
                border-top: $border-component;
                padding: 0 $hmg_mid;
                position: relative;
                text-align: center;
                justify-content: space-between;
                z-index: 8;

              .input-control{
                border: none !important;
              }
                
                
                &:first-child {
                  border-left: none !important;
                }
                &:last-child {
                  border-right: none !important;
                }

                &.over {
                  background-color: $color-debito;
                }
                &.under {
                  background-color: $color-credito;
                }

                &.fullCell {
                  padding: 0;
                  gap: $mg_small;
                }

                .fullCell{
                  display: flex;
                  justify-content: space-between;
                  width: 100%;
                }

                // .arrowTag {
                //   display: flex; flex-direction: column;
                //   justify-content: center; align-items: center;
                //   position: absolute; top: 50%; left: 0;
                //   transform: translate(-50%, -50%);
                //   width: 21px; height: 21px;
                //   border-radius: 100%; border: $border-component;
                //   font-size: 10px;
                //   z-index: 12;
                //   color: $vermelho; background-color: $color-secondary;

                //   &.over {
                //     color: $color-primary;
                //   }

                //   &.under {
                //     color: $color-success-2;
                //   }
                // }

                &.arrowCell {
                  >div {
                    display: flex; align-items: center; justify-content: center;
                    gap: $hmg_mini
                  }
                }

                .multiple {
                  display: flex; align-items: center;
                  gap: $mg_mini; overflow: hidden;
                  
                  span {
                    display: block;
                    width: 24px; height: 24px;
                    text-align: center; line-height: 24px;
                    flex-shrink: 0;
                    border: $border-component;
                    border-radius: 100%;
                  }
                  p {
                    margin: 0; padding: 0;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                  }
                }
              }

              &.spinner {
                height: auto;

                td {
                  background-color: $color-secondary;
                  padding: 0 !important;
                }
              }
              &.subHeader {
                height: 40px;
                background-color: $color-bg;

                h4 {
                  margin: 0; padding: 0;
                }
              }

              &:last-child {
                td {
                  border-bottom: none !important;

                  &:last-child {
                    border-right: none !important;
                    border-bottom-right-radius: $border-radius;
                  }
                }
              }
            }
          }
        }
// }
.modal-main{
  display: flex;
  flex-direction: column;
  padding: $mg-small;
}

.modal-acordo {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;

  .modal-overlay {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.4);
  }

  .modal-content {
    position: relative;
    background: $branco;
    border-radius: $border-radius-mid;
    width: 700px;
    max-width: 90%;
    @extend %shadow-high;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .modal-header {
      padding: $hmg;
      border-bottom: $border-component;
      h2 {
        
        .step {
          color: $cinza-escuro;
          margin-right: 0.5rem;
          font-weight: normal;
        }
      }
    }

    .modal-summary {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 1rem 1.5rem;
      border: $border-component;

      .summary-text {
        .summary-main {
          font-size: $font-size-large;
          color: $preto;
          margin: 0;
        }
        .summary-sub {
          font-size: $font-size-small;
          color: $cinza-escuro;
          margin-top: 0.25rem;
        }
      }
      .summary-total {
        font-size: 1.5rem;
        font-weight: bold;
        color: $vermelho;
      }
    }

    .modal-body-4{
        border: $border-component;
        border-top: none;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        padding: 0 !important;
        height: 30rem;
        overflow-y: auto;
        @extend %scrollbar_light;
    }
        .modal-body-3 {
        border: $border-component;
        border-top: none;
        display: flex;
        align-items: center;
        flex-direction: column;
        padding: 0 !important;
        height: auto;
        max-height: 30rem;
        overflow-y: auto;
        @extend %scrollbar_light;
        }

    .modal-body {
        border: $border-component;
        border-top: none;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        padding: 0 !important;
        height: 20rem;
        overflow-y: auto;
        @extend %scrollbar_light;

        .field {
          width: 70%;
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: end;
            margin-bottom: 1rem;
            gap: $mg-mini;

            .field-label {
              width: 12rem;
              align-items: end;
            // flex: 1;
            span {
                display: block;
                font-size: $font-size;
                color: $preto;
            }
            small {
                display: block;
                font-size: $font-size-small;
                color: $cinza-escuro;
                margin-top: 0.25rem;
            }
            }

            .arrowTag {
            display: flex; flex-direction: column;
            justify-content: center; align-items: center;
            position: absolute; top: 50%; left: 0;
            transform: translate(-50%, -50%);
            width: 21px; height: 21px;
            border-radius: 100%; border: $border-component;
            font-size: 10px;
            z-index: 12;
            color: $vermelho; background-color: $color-secondary;
            &.over {
                color: $color-primary;
            }
            &.under {
                color: $color-success-2;
            }
            }

            .field-control {
            display: flex;
            align-items: center;

            .input-circle {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 5rem;
                color: $cinza-escuro;
                height: 5rem;
                border: $border-component;
                border-radius: $border-radius;
                input {
                width: 2rem;
                border: none;
                font-size: $font-size-large;
                text-align: right;
                &:focus { outline: none; }
                }
                .unit {
                margin-left: 0.25rem;
                font-size: $font-size;
                }
            }

            .field-equals {
              display: flex;
              width: 15rem;
              justify-content: flex-start;
              align-items: center;
                font-size: $font-size;
                color: $cinza-escuro;
                strong {
                margin-left: 0.25rem;
                }
            }
            }
        }
    }

    .modal-footer {
      padding: 1rem 1.5rem;
      background: $cinza-claro;
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>
